import React, { useEffect, useRef, useState } from "react";
import EducationCoursePage from "./EducationCoursePage";
import EducationTeacherPage from "./EducationTeacherPage";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import HeaderComponent from "../../components/header/headerComponent";
import { useTranslation } from "react-i18next";
import {
    ArrowLeftOutlined
} from '@ant-design/icons';

const EducationCourseMainPage = (props) => {
  const { t } = useTranslation();
   const location = useLocation();
   const navigate = useNavigate();
   const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");

  const toggleView = (_id) => {
    navigate(`/education-course?id=${_id}`)
  };

  const toggleViewTeacher = (_id) => {
    navigate(`/education-course`)
  };
  
  return (
    <>
    <HeaderComponent pageTitle={id ? <span style={{cursor: "pointer"}} onClick={toggleViewTeacher}><ArrowLeftOutlined /> {t('Education Management / Teacher-related Course Management')}</span> : t('Education Management')} >
      {
        id ? <EducationTeacherPage toggleView={toggleViewTeacher} /> : <EducationCoursePage toggleView={toggleView} />

      }
      </HeaderComponent>
    </>
  )
}

export default EducationCourseMainPage